export const settings = {
  baseApiUrl: process.env.REACT_APP_BASE_API_URL,
};

export const PROMPT_TAGS = ['objective', 'guideline', 'context', 'example'];

// These need to match the action keys in Integration App
export enum ActionKey {
  RETRIEVE_AVAILABILITY = 'retrieve-availability',
  BOOK_APPOINTMENT = 'book-appointment',
  GET_EVENT_TYPES = 'get-event-types',
  LIST_BOARDS = 'list-boards',
  LIST_GROUPS = 'list-groups',
  LIST_DATA_RECORDS = 'list-data-records',
}

// Variables available for post-call messages (Email/SMS) that map to Call fields
// Keep names in single-brace form to match current editors
// Ordered by most useful first per UX feedback
export const POST_CALL_VARIABLES: string[] = [
  '{transcript}',
  '{human_detection_result}',
  '{post_call_results}',
  '{from_number}',
  '{to_number}',
  '{status}',
  '{recording_available}',
  '{stage}',
  '{stage_outcome}',
  '{start_time}',
  '{end_time}',
  '{errors}',
  '{do_not_call_result}',
  '{telephony_provider}',
  '{telephony_account_connection}',
  '{is_outgoing}',
  '{telephony_id}',
  '{telephony_metadata}',
  '{id}',
  '{user_id}',
];

// Variables commonly available in Agent prompts by default
export const AGENT_PROMPT_VARIABLES: string[] = [
  '{today}',
  '{tomorrow}',
  '{agent_phone}',
  '{user_phone}',
];
